import { render, staticRenderFns } from "./PurchasesProfileButton.vue?vue&type=template&id=36e11736"
import script from "./PurchasesProfileButton.vue?vue&type=script&lang=js"
export * from "./PurchasesProfileButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports